/* istanbul ignore file */
export { default } from './RrpIppOrderSummary';
